import React from 'react'
import { routesDef } from '../../config/routes'
import { useMutation } from '@ztechapps/common.hook'
import type { FormikBag } from 'formik'
import { Field, Form } from '@ztechapps/webui.form'
import { CreateButtonInput } from '../../components/CreateButtonInput'
import { productQueries } from '@ztechapps/product.common'

export const AddNewProductForm = ({ onSuccessSubmit }: { onSuccessSubmit: (route: string) => void }) => {
  const [onAdd, , { loading }] = useMutation({ ...productQueries.createConfig })

  const initialValues = {
    code: '',
  }
  type FormType = typeof initialValues
  const validate = (values: FormType) => {
    const errors: Partial<FormType> = {}
    if (!values.code) {
      errors.code = 'Required'
    }
    return errors
  }

  const onSubmit = async (values: FormType, formikBag: FormikBag<FormType, FormType>) => {
    try {
      //do the submission here
      const input = {
        name: values.code,
        code: values.code,
      }

      const { data, errors } = await onAdd({ input })
      if (errors) throw errors

      // if then navigate to necessary field is no error then navigate to
      const route = routesDef.ProductItemPage.altPath({
        _id: data?.createProduct?._id,
      })

      onSuccessSubmit(route)
    } catch (e) {
      formikBag.setFieldError('code', e.message)
    }
  }

  return (
    <Form onSubmit={onSubmit} initialValues={initialValues} validate={validate}>
      <Field
        label={'Code'}
        help="The code of the product. Press Enter or click the button to create the product."
        name="code"
        placeholder={'Product code'}
        loading={loading}
        component={CreateButtonInput}
      />
    </Form>
  )
}
